import { Identity } from '../types/auth';

/** CDU Discord guild id on TicketsX. */
export const TICKETSX_GUILD_ID = '940907977014120488';

export function getTicketsxTranscriptUrl(ticketId: number | string): string {
  return `https://ticketsx.xyz/${TICKETSX_GUILD_ID}/transcripts/${ticketId}`;
}

/**
 * Same admin-and-up triple the backend transcript proxy enforces; mirrors
 * CONFIDENTIAL_VIEWER_GROUPS in utils/evidence.ts but is a separate policy.
 */
const TRANSCRIPT_VIEWER_GROUPS = ['SPY_Bans_Admin', 'SPY_Bans_Superadmins', 'SPY_Super_admin'];

export function canViewTicketTranscript(identity: Identity | null): boolean {
  if (import.meta.env.DEV) return true;
  if (!identity) return false;
  const groups = identity.raw.custom.groups;
  return TRANSCRIPT_VIEWER_GROUPS.some(g => groups.includes(g));
}

/**
 * Parse a ticket id into a positive integer, or null when invalid.
 * Kanban card links carry ticket ids as strings (link_target_id).
 */
export function parseTicketId(id: number | string): number | null {
  const n = typeof id === 'number' ? id : Number(String(id).trim().replace(/^#/, ''));
  return Number.isInteger(n) && n > 0 ? n : null;
}
